import { Action, createReducer, on } from '@ngrx/store';
import * as featureActions from './shared.actions';
import { IPagination } from '../models/page.model';
import { FetchProductsSuccess, SetProductLoader, SetSearchProductLoader, SetVariantsLoader } from 'src/app/features/produits/store/produits.actions';
import { FetchCategoriesSuccess, SetCategoriesLoader } from 'src/app/features/categories/store/categories.actions';
import { FetchBrandsSuccess, SetBrandsLoader } from 'src/app/features/brands/store/brands.actions';
import { FetchCustomersSuccess, SetCompanyLoader, SetCountryLoader, SetCurrenciesLoader, SetCustomersLoader, SetPaymentTermsLoader, SetSearchCompanyLoader, SetStatesLoader } from 'src/app/features/customers/store/customers.actions';
import { FetchTagsSuccess, SetTagsLoader } from 'src/app/features/tags/store/tags.actions';
import { FetchCatalogsSuccess, SetCatalogLoader, SetSearchCatalogsLoader } from 'src/app/features/catalogs/store/catalogs.actions';
import { FetchAllCompaniesGroupsSuccess, SetGroupsLoader, SetSearchGroupLoader } from 'src/app/features/companies-groups/store/companies-groups.actions';
import { SetAuthLoading } from 'src/app/features/auth/authentication/store/auth.actions';
import { GetQuotationsSuccess, SetQuotationsLoader } from 'src/app/features/quotations/store/quotations.actions';
import { GetImportsSuccess, SetExecuteImportLoader, SetImportLoader } from 'src/app/features/imports/store/imports.actions';
import { FetchSegmentsSuccess, SetSearchSegmentLoader, SetSegmentsLoader } from 'src/app/features/segments/store/segments.actions';
import { SetCustomFieldsLoader, SetNotificationsLoader, SetUsersLoader } from 'src/app/features/settings/store/settings.actions';
import { GetOrdersSuccess, SetSearchOrdersLoader } from 'src/app/features/orders/store/orders.actions';
import { GetComparatorsSuccess, SetComparatorLoader, SetExecuteComparatorsLoader } from 'src/app/features/comparator/store/comparator.actions';
import { FetchSuppliersSuccess, SetSupplierLoader } from 'src/app/features/suppliers/store/suppliers.actions';
import { GetAgentsSuccess, SetAgentLoader } from 'src/app/features/agents/store/agents.actions';
import { SetPricebookLoader } from 'src/app/features/pricebook/store/pricebook.actions';
import { LoadAliasesSuccess } from 'src/app/features/knowledge-base/store/aliases.actions';
import { LoadExternalReferencesSuccess } from 'src/app/features/knowledge-base/store/external-references.actions';
export interface SharedState {
  isAppLoading: boolean;
  currentMetaDat: IPagination | null
  activeLoaders: number;
  navbarParams: { title: string | null, breadcrumbs: {label: string, url: string | null }[] | [], parentPath: string | null, icon: string | null }
}
export const initialAuthState: SharedState = {
  isAppLoading: false,
  currentMetaDat: null,
  activeLoaders: 0,
  navbarParams: {title: null, breadcrumbs: [], parentPath: null, icon: null}
};

const featureReducer = createReducer(
  initialAuthState,
  on(FetchProductsSuccess, (state, action) => ({ ...state, currentMetaDat: action.products.metadata })),
  on(FetchCategoriesSuccess, (state, action) => ({ ...state, currentMetaDat: action.categories.metadata })),
  on(FetchBrandsSuccess, (state, action) => ({ ...state, currentMetaDat: action.brands.metadata })),
  on(FetchTagsSuccess, (state, action) => ({ ...state, currentMetaDat: action.tags.metadata })),
  on(FetchCustomersSuccess, (state, action) => ({ ...state, currentMetaDat: action.customers.metadata })),
  on(FetchCatalogsSuccess, (state, action) => ({ ...state, currentMetaDat: action.catalogs.metadata })),
  on(FetchAllCompaniesGroupsSuccess, (state, action) => ({ ...state, currentMetaDat: action.companiesGroups.metadata })),
  on(FetchSuppliersSuccess, (state, action) => ({ ...state, currentMetaDat: action.suppliers.metadata })),
  on(GetAgentsSuccess, (state, action) => ({ ...state, currentMetaDat: action.agents.metadata })),
  on(GetQuotationsSuccess, (state, action) => ({ ...state, currentMetaDat: action.res.metadata })),
  on(GetOrdersSuccess, (state, action) => ({ ...state, currentMetaDat: action.res.metadata })),
  on(GetImportsSuccess, (state, action) => ({ ...state, currentMetaDat: action.imports.metadata })),
  on(GetComparatorsSuccess, (state, action) => ({ ...state, currentMetaDat: action.Comparators.metadata })),
  on(SetAuthLoading, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetProductLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetCategoriesLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetTagsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetBrandsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetCatalogLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetCustomersLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetCompanyLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetCurrenciesLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetPaymentTermsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetCountryLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetStatesLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetGroupsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetVariantsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetSearchProductLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetSearchCompanyLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetSearchOrdersLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetSearchCatalogsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetSearchSegmentLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetSearchGroupLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetQuotationsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetImportLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetExecuteImportLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetSegmentsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetUsersLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1,
  })),
  on(SetNotificationsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetComparatorLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetExecuteComparatorsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetSupplierLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetAgentLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(SetPricebookLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  })),
  on(FetchSegmentsSuccess, (state, action) => ({ ...state, currentMetaDat: action.segments.metadata })),
  on(LoadAliasesSuccess, (state, action) => ({ ...state, currentMetaDat: action.response.metadata })),
  on(LoadExternalReferencesSuccess, (state, action) => ({ ...state, currentMetaDat: action.response.metadata })),
  on(featureActions.SetNavbarParams, (state, action) => ({
    ...state,
    navbarParams: action
  })),
  on(featureActions.ResetLoader, (state, action) => ({
    ...state,
    isAppLoading: action.disable_loader ? false : state.isAppLoading,
    activeLoaders: action.disable_loader ? 0 : state.activeLoaders
  })),
  on(SetCustomFieldsLoader, (state, action) => ({
    ...state,
    activeLoaders: action.isLoading ? state.activeLoaders + 1 : state.activeLoaders - 1,
    isAppLoading: action.isLoading ? true : state.activeLoaders > 1
  }))
);

export function sharedReducer(state: SharedState | undefined, action: Action) {
  return featureReducer(state, action);
}
